import ModuleSummaryContainer from './ModuleSummaryContainer'

export default ModuleSummaryContainer
